import React from 'react';
import ContentLoader from 'react-content-loader'
const PropertyListCardLoader = (props) => {
    return (
        <div className="card">
        <ContentLoader
            speed={2}
            width={320}
            height={450}
            viewBox="0 0 320 450"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <rect x="293" y="0" rx="0" ry="0" width="0" height="10" />
            <rect x="-1" y="3" rx="0" ry="0" width="374" height="4" />
            <rect x="2" y="0" rx="0" ry="0" width="5" height="467" />
            <rect x="3" y="444" rx="0" ry="0" width="337" height="5" />
            <rect x="316" y="2" rx="0" ry="0" width="44" height="458" />
            <rect x="8" y="410" rx="0" ry="0" width="319" height="5" />
            <rect x="56" y="415" rx="0" ry="0" width="2" height="29" />
            <rect x="103" y="415" rx="0" ry="0" width="5" height="32" />
            <rect x="10" y="215" rx="0" ry="0" width="301" height="6" />
            <rect x="27" y="255" rx="0" ry="0" width="275" height="22" />
            <rect x="27" y="301" rx="0" ry="0" width="274" height="22" />
            <rect x="26" y="348" rx="0" ry="0" width="273" height="20" />
            <rect x="13" y="208" rx="0" ry="0" width="8" height="4" />
            <rect x="98" y="94" rx="0" ry="0" width="7" height="4" />
            <rect x="9" y="4" rx="0" ry="0" width="307" height="217" />
            <rect x="5" y="5" rx="0" ry="0" width="91" height="213" />
        </ContentLoader>
        </div>
    )

};

export default PropertyListCardLoader;